import { Component, Input } from '@angular/core';

import { Fieldset } from 'primeng/fieldset';

@Component({
  selector: 's-form-group',
  templateUrl: './s-form-group.component.html',
  styleUrls: ['./s-form-group.component.css'],
  standalone: true,
  imports: [Fieldset]
})
export class SFormGroupComponent {
  @Input() title: string;
}
